import { useQuery } from '@tanstack/react-query'
import api from '../api/client'
import type { ActivityResponse } from '../types'

// Tester activity view (per-user + cohort). Read-only; admin-gated server-side.
export function useAdminActivity(activeWindowDays = 7) {
  return useQuery<ActivityResponse>({
    queryKey: ['admin-activity', activeWindowDays],
    queryFn: () =>
      api
        .get('/api/v1/admin/analytics/activity/', {
          params: { active_window_days: activeWindowDays },
        })
        .then((r) => r.data),
    staleTime: 60_000, // behavioural data changes slowly; 1 min is plenty
  })
}
